"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const script_1 = __importDefault(require("next/script"));
const Saam = () => {
    return (react_1.default.createElement(script_1.default, { crossOrigin: true, strategy: "lazyOnload", src: `https://ssr.col.movistar.es/sw/static/${process.env.NEXT_PUBLIC_VERSION_JS}/sa2m/sa2min.js` }));
};
exports.default = Saam;
//# sourceMappingURL=index.js.map